import { render, staticRenderFns } from "./Ricerche.vue?vue&type=template&id=0cffb0de&scoped=true&"
import script from "./Ricerche.vue?vue&type=script&lang=js&"
export * from "./Ricerche.vue?vue&type=script&lang=js&"
import style0 from "./Ricerche.vue?vue&type=style&index=0&id=0cffb0de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cffb0de",
  null
  
)

export default component.exports